import { SupportedLocale } from '@/utils/intl';
import { useCurrentLocale } from '@rhg/hooks/use-current-language';
import dynamic from 'next/dynamic';
import { PropsWithChildren } from 'react';

const EnLocalizationProvider = dynamic(() =>
    import('./lang/en').then((mod) => mod.EnLocalizationProvider)
);

const EsLocalizationProvider = dynamic(() =>
    import('./lang/es').then((mod) => mod.EsLocalizationProvider)
);

const FrLocalizationProvider = dynamic(() =>
    import('./lang/fr').then((mod) => mod.FrLocalizationProvider)
);

const DeLocalizationProvider = dynamic(() =>
    import('./lang/de').then((mod) => mod.DeLocalizationProvider)
);

const ItLocalizationProvider = dynamic(() =>
    import('./lang/it').then((mod) => mod.ItLocalizationProvider)
);

const JaLocalizationProvider = dynamic(() =>
    import('./lang/ja').then((mod) => mod.JaLocalizationProvider)
);

const KoLocalizationProvider = dynamic(() =>
    import('./lang/ko').then((mod) => mod.KoLocalizationProvider)
);

const PlLocalizationProvider = dynamic(() =>
    import('./lang/pl').then((mod) => mod.PlLocalizationProvider)
);

const PtLocalizationProvider = dynamic(() =>
    import('./lang/pt').then((mod) => mod.PtLocalizationProvider)
);

const EnGBLocalizationProvider = dynamic(() =>
    import('./lang/en-GB').then((mod) => mod.EnGBLocalizationProvider)
);

const EnCALocalizationProvider = dynamic(() =>
    import('./lang/en-CA').then((mod) => mod.EnCALocalizationProvider)
);

const PtBRLocalizationProvider = dynamic(() =>
    import('./lang/pt-BR').then((mod) => mod.PtBrLocalizationProvider)
);

const ZhTwLocalizationProvider = dynamic(() =>
    import('./lang/zh-TW').then((mod) => mod.ZhTwLocalizationProvider)
);

export function LocalizationProvider({ ...props }: PropsWithChildren) {
    const locale = useCurrentLocale();
    switch (locale) {
        case SupportedLocale.DE:
            return <DeLocalizationProvider {...props} />;
        case SupportedLocale.ES:
            return <EsLocalizationProvider {...props} />;
        case SupportedLocale.FR:
            return <FrLocalizationProvider {...props} />;
        case SupportedLocale.IT:
            return <ItLocalizationProvider {...props} />;
        case SupportedLocale.JA:
            return <JaLocalizationProvider {...props} />;
        case SupportedLocale.KO:
            return <KoLocalizationProvider {...props} />;
        case SupportedLocale.PL:
            return <PlLocalizationProvider {...props} />;
        case SupportedLocale.PT:
            return <PtLocalizationProvider {...props} />;
        case SupportedLocale.ENgb:
            return <EnGBLocalizationProvider {...props} />;
        case SupportedLocale.ENca:
            return <EnCALocalizationProvider {...props} />;
        case SupportedLocale.PTbr:
            return <PtBRLocalizationProvider {...props} />;
        case SupportedLocale.ZH:
        case SupportedLocale.ZHtw:
            return <ZhTwLocalizationProvider {...props} />;
        default:
            return <EnLocalizationProvider {...props} />;
    }
}
